export const updateFilterHide = (filterHide) => {
    return (dispatch, getState) => {
        dispatch({ type: 'UPDATE_FILTER_HIDE', filterHide })
    }
}
